var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var ProjectManager = /** @class */ (function () {
    function ProjectManager(sourcesStore, channelsStore, channelId) {
        this.nextSaveTime = null;
        this.saveInterval = 30 * 1000; // 30 seconds
        this.saveInProgress = false;
        this.saveQueued = false;
        this.saveSuccessListeners = [];
        this.saveNoopListeners = [];
        this.saveFailListeners = [];
        this.saveStartListeners = [];
        this.destroyed = false;
        this.channelId = channelId;
        this.sourcesStore = sourcesStore;
        this.channelsStore = channelsStore;
    }
    // Load the project from the sources and channels store.
    ProjectManager.prototype.load = function () {
        return __awaiter(this, void 0, void 0, function () {
            var sourceResponse, source, channelResponse, _a, channelString, project, blob;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (this.destroyed) {
                            return [2 /*return*/, this.getNoopResponse()];
                        }
                        return [4 /*yield*/, this.sourcesStore.load(this.channelId)];
                    case 1:
                        sourceResponse = _b.sent();
                        source = {};
                        if (!sourceResponse.ok) return [3 /*break*/, 3];
                        return [4 /*yield*/, sourceResponse.json()];
                    case 2:
                        source = _b.sent();
                        this.lastSource = JSON.stringify(source);
                        _b.label = 3;
                    case 3: return [4 /*yield*/, this.channelsStore.load(this.channelId)];
                    case 4:
                        channelResponse = _b.sent();
                        if (!channelResponse.ok) {
                            return [2 /*return*/, channelResponse];
                        }
                        _a = this;
                        return [4 /*yield*/, channelResponse.json()];
                    case 5:
                        _a.channel = _b.sent();
                        channelString = JSON.stringify(this.channel);
                        project = { source: source, channel: channelString };
                        blob = new Blob([JSON.stringify(project)], {
                            type: 'application/json',
                        });
                        return [2 /*return*/, new Response(blob)];
                }
            });
        });
    };
    ProjectManager.prototype.hasUnsavedChanges = function () {
        return this.sourceChanged();
    };
    // Shut down this project manager. All we do here is clear the existing
    // timeout, if it exists.
    ProjectManager.prototype.destroy = function () {
        this.resetSaveState();
        this.destroyed = true;
    };
    // Save any enqueued unsaved changes, then destroy the project manager.
    ProjectManager.prototype.cleanUp = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.sourceToSave) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.save(this.sourceToSave, true)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        this.destroy();
                        return [2 /*return*/];
                }
            });
        });
    };
    // TODO: Add functionality to reduce channel updates during
    // HoC "emergency mode" (see 1182-1187 in project.js).
    /**
     * Enqueue a save to happen in the next saveInterval, unless a force save is requested.
     * If a save is already enqueued, update this.sourceToSave with the given source.
     * @param source Source: the source to save
     * @param forceSave boolean: if the save should happen immediately
     * @returns a promise that resolves to a Response. If the save is successful, the response
     * will be empty, otherwise it will contain failure information.
     */
    ProjectManager.prototype.save = function (source, forceSave) {
        if (forceSave === void 0) { forceSave = false; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (this.destroyed) {
                    // If we have already been destroyed, don't attempt to save.
                    this.resetSaveState();
                    return [2 /*return*/, this.getNoopResponseAndSendSaveNoopEvent()];
                }
                this.sourceToSave = source;
                if (!this.canSave(forceSave)) {
                    if (!this.saveQueued) {
                        this.enqueueSave();
                    }
                    return [2 /*return*/, this.getNoopResponseAndSendSaveNoopEvent()];
                }
                else {
                    this.saveHelper();
                }
                return [2 /*return*/];
            });
        });
    };
    ProjectManager.prototype.addSaveSuccessListener = function (listener) {
        this.saveSuccessListeners.push(listener);
    };
    ProjectManager.prototype.addSaveNoopListener = function (listener) {
        this.saveNoopListeners.push(listener);
    };
    ProjectManager.prototype.addSaveFailListener = function (listener) {
        this.saveFailListeners.push(listener);
    };
    ProjectManager.prototype.addSaveStartListener = function (listener) {
        this.saveStartListeners.push(listener);
    };
    // TODO: Add rename function. Rename sets the name on the channel.
    // https://codedotorg.atlassian.net/browse/SL-891
    /**
     * Helper function to save a project, called either after a timeout or directly by save().
     * On a save, we check if there are unsaved changes. If there are none, we can skip the save.
     * Only if the source save succeeds do we update the channel, as the
     * channel is metadata about the project and we don't want to save it unless the source
     * save succeeded.
     * @returns a Response. If the save is successful, the response will be empty,
     * otherwise it will contain failure or no-op information.
     */
    ProjectManager.prototype.saveHelper = function () {
        return __awaiter(this, void 0, void 0, function () {
            var sourceResponse, channelResponse, channelSaveResponse;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.sourceToSave || !this.channel) {
                            return [2 /*return*/, this.getNoopResponseAndSendSaveNoopEvent()];
                        }
                        this.resetSaveState();
                        this.saveInProgress = true;
                        this.nextSaveTime = Date.now() + this.saveInterval;
                        this.executeSaveStartListeners();
                        // If the source has not actually changed, no need to save again.
                        if (!this.sourceChanged()) {
                            this.saveInProgress = false;
                            return [2 /*return*/, this.getNoopResponseAndSendSaveNoopEvent()];
                        }
                        return [4 /*yield*/, this.sourcesStore.save(this.channelId, this.sourceToSave)];
                    case 1:
                        sourceResponse = _a.sent();
                        if (!sourceResponse.ok) {
                            this.saveInProgress = false;
                            this.executeSaveFailListeners(sourceResponse);
                            // TODO: Should we wrap this response in some way?
                            // Maybe add a more specific statusText to the response?
                            return [2 /*return*/, sourceResponse];
                        }
                        this.lastSource = JSON.stringify(this.sourceToSave);
                        return [4 /*yield*/, this.channelsStore.save(this.channel)];
                    case 2:
                        channelResponse = _a.sent();
                        if (!channelResponse.ok) {
                            this.saveInProgress = false;
                            this.executeSaveFailListeners(channelResponse);
                            // TODO: Should we wrap this response in some way?
                            // Maybe add a more specific statusText to the response?
                            return [2 /*return*/, channelResponse];
                        }
                        return [4 /*yield*/, channelResponse.json()];
                    case 3:
                        channelSaveResponse = _a.sent();
                        this.saveInProgress = false;
                        this.channel = channelSaveResponse;
                        this.executeSaveSuccessListeners(this.channel, this.sourceToSave);
                        return [2 /*return*/, new Response()];
                }
            });
        });
    };
    ProjectManager.prototype.canSave = function (forceSave) {
        if (this.saveInProgress) {
            return false;
        }
        else if (forceSave) {
            // If this is a force save, don't wait until the next save time.
            return true;
        }
        else if (this.nextSaveTime) {
            return this.nextSaveTime <= Date.now();
        }
        return true;
    };
    ProjectManager.prototype.enqueueSave = function () {
        var _this = this;
        this.saveQueued = true;
        this.currentTimeoutId = window.setTimeout(function () {
            _this.saveHelper();
        }, this.nextSaveTime ? this.nextSaveTime - Date.now() : this.saveInterval);
    };
    ProjectManager.prototype.getNoopResponse = function () {
        return new Response(null, { status: 304 });
    };
    ProjectManager.prototype.getNoopResponseAndSendSaveNoopEvent = function () {
        var noopResponse = this.getNoopResponse();
        this.executeSaveNoopListeners(this.channel);
        return noopResponse;
    };
    ProjectManager.prototype.sourceChanged = function () {
        if (!this.sourceToSave) {
            return false;
        }
        return this.lastSource !== JSON.stringify(this.sourceToSave);
    };
    ProjectManager.prototype.resetSaveState = function () {
        if (this.currentTimeoutId !== undefined) {
            window.clearTimeout(this.currentTimeoutId);
            this.currentTimeoutId = undefined;
        }
        this.saveQueued = false;
    };
    // LISTENERS
    ProjectManager.prototype.executeSaveSuccessListeners = function (channel, source) {
        this.saveSuccessListeners.forEach(function (listener) { return listener(channel, source); });
    };
    ProjectManager.prototype.executeSaveNoopListeners = function (channel) {
        this.saveNoopListeners.forEach(function (listener) { return listener(channel); });
    };
    ProjectManager.prototype.executeSaveFailListeners = function (response) {
        this.saveFailListeners.forEach(function (listener) { return listener(response); });
    };
    ProjectManager.prototype.executeSaveStartListeners = function () {
        this.saveStartListeners.forEach(function (listener) { return listener(); });
    };
    return ProjectManager;
}());
export default ProjectManager;
